import React, {
  MutableRefObject,
} from 'react';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';

import { useSelector } from 'app/store/utils/redux/hooks';

type HeaderProps = {
  flipbookRef?: MutableRefObject<any>,
};

const Hint = (props: HeaderProps) => {
  const {
    flipbookRef,
  } = props;
  const classes = useStyles();
  const isShow = useSelector((state) => state?.hint.isShow || false);

  return (
    <div className={cn(classes.componentHint, { isShow })}>
      <div className="text">
        Tap corner to turn page
        <span>&gt;</span>
      </div>
      {/* <div className="image">
        <img src={upPointingHand} alt="up pointing hand" />
      </div> */}
    </div>
  );
};

const useStyles = createUseStyles({
  componentHint: {
    '&': {
      display: 'flex',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      opacity: 0,
      transition: 'opacity 300ms ease',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1.8rem 0 0',
      boxSizing: 'border-box',
      transform: 'translateY(100%)',
      color: '#3F3F3F',
      pointerEvents: 'none',
      zIndex: 1,
    },
    '& > .text': {
      '&': {
        display: 'flex',
        fontFamily: 'Avenir Next Demi, sans-serif',
        fontWeight: 600,
        fontSize: '1.3rem',
        lineHeight: 1.4,
        marginLeft: '.5rem',
      },
      '& span': {
        display: 'block',
        transform: 'rotate(-90deg)',
        marginLeft: '0.7rem',
      },
    },
    '& > .image': {
      '&': {
        width: '3.8rem',
        marginLeft: '1.2rem',
      },
      '& img': {
        width: '100%',
        height: 'auto',
        transform: 'translateY(.7rem)',
        transition: 'transform 600ms cubic-bezier(.55,.56,.14,.99) 300ms',
      },
    },
    '&.isShow': {
      '&': {
        pointerEvents: 'all',
        opacity: 1,
      },
      '& .image img': {
        transform: 'translateY(-.6rem)',
      },
    },
  },
});

export default Hint;
